<template>
    <div id="CheckoutShipping" class="checkout-step" :class="{active: getCheckoutStep === 3}">
        <p class="heading">Recipient details</p>
        <hr>
        <div class="holder">
            <div>
                <label for="member-email">Email*</label>
                <input id="member-email" type="text" name="Phone" v-model="getMember.Email"
                       placeholder="eg. yourname@domain.com"/>
            </div>
            <div>
                <label for="member-phone">Phone Number</label>
                <input id="member-phone" type="text" name="Phone" v-model="getMember.DefaultShippingAddress.Phone" placeholder="eg. +64 21 1234567"/>
            </div>
            <div class="inline-field">
                <label for="member-firstname">First Name*</label>
                <input id="member-firstname" type="text" name="FirstName" v-model="getMember.FirstName"/>
            </div>
            <div class="inline-field">
                <label for="member-surname">Surname*</label>
                <input id="member-surname" type="text" name="Surname" v-model="getMember.Surname"/>
            </div>

            <p class="toggle-more" @click="showGiftNotes = !showGiftNotes"><i class="fal fa-comment-alt-plus"></i>Add Gift Message</p>
            <div v-if="showGiftNotes">
                <label for="gift-notes">Gift Message</label>
                <textarea id="gift-notes" type="text" name="GiftNote" v-model="giftNotes"/>
            </div>
        </div>

        <p class="heading">Shipping options</p>
        <hr>

        <div class="shipping-option" v-if="getOrder && getOrder.Unshippable">
            <input id="email-option" Name="ShippingMethod" type="radio" value="email" v-model="shippingMethod">
            <label for="email-option" :class="{active: getShippingMethod === 'email'}">By email</label>
            <i class="fal fa-gift-card"></i>
        </div>

        <div class="shipping-option" v-if="getOrder && getOrder.AllowPickup">
            <input id="pickup-option" Name="ShippingMethod" type="radio" value="pickup" v-model="shippingMethod">
            <label for="pickup-option" :class="{active: getShippingMethod === 'pickup'}">Pick up my order</label>
            <i class="fal fa-hand-receiving"></i>
        </div>

        <div class="shipping-option">
            <input id="deliver-option" Name="ShippingMethod" type="radio" value="shipping" v-model="shippingMethod"/>
            <label for="deliver-option" :class="{active: getShippingMethod === 'shipping'}">Deliver to my address</label>
            <i class="fal fa-truck"></i>
            <div class="option-body" v-if="getShippingMethod === 'shipping'">
                <form class="wc-form" @submit.prevent="handleShipping()">
                    <div>
                        <label for="shipping-country">Country</label>
                        <v-select id="shipping-country"
                                  v-model="shippingCountry"
                                  :options="getShippingCountries"
                                  :reduce="country => country.code"
                                  :clearable="false"
                                  label="country">
                        </v-select>
                    </div>
                    <div>
                        <label for="shipping-autocomplete">Address</label>
                        <gmap-autocomplete :options="autocompleteOptions()" @place_changed="autoCompleteAddress"
                                           @keydown.native.enter.prevent placeholder="Start typing and find your address"
                                           :value="getMember.DefaultShippingAddress.FullAddress"
                                           :key="getMember.DefaultShippingAddress.Country" id="shipping-autocomplete"></gmap-autocomplete>
                    </div>
                    <div>
                        <label for="shipping-address">Street Address</label>
                        <input id="shipping-address" type="text" name="Address" v-model="getMember.DefaultShippingAddress.Address"/>
                    </div>
                    <div>
                        <label for="shipping-suburb">Suburb</label>
                        <input id="shipping-suburb" type="text" name="Suburb" v-model="getMember.DefaultShippingAddress.Suburb"/>
                    </div>
                    <div>
                        <label for="shipping-city">City</label>
                        <input id="shipping-city" type="text" name="City" v-model="getMember.DefaultShippingAddress.City"/>
                    </div>
                    <div>
                        <label for="shipping-state">Region</label>
                        <input id="shipping-state" type="text" name="State" v-model="getMember.DefaultShippingAddress.State"/>
                    </div>
                    <div>
                        <label for="shipping-postcode">Postal Code</label>
                        <input id="shipping-postcode" type="text" name="PostalCode" v-model="getMember.DefaultShippingAddress.PostalCode"/>
                    </div>

                    <p class="toggle-more" @click="showShippingNotes = !showShippingNotes"><i class="fal fa-comment-alt-plus"></i>Add Delivery
                        Instructions</p>
                    <div v-if="showShippingNotes">
                        <label for="shipping-notes">Shipping Notes</label>
                        <textarea id="shipping-notes" type="text" name="ShippingNotes" v-model="shippingNotes"/>
                    </div>
                </form>
            </div>
        </div>

        <div class="locale-warning" v-if="getOrder && getOrder.Locale === 'en_US'">
            <p><strong>WARNING:</strong> Drinking distilled spirits, beer, coolers, wine and other alcoholic beverages may increase cancer risk, and, during pregnancy, can cause birth defects. For more information go to <a href="https://www.P65Warnings.ca.gov/alcohol" target="_blank">www.P65Warnings.ca.gov/alcohol</a>.</p>
        </div>

        <p class="checkout-form-error" v-if="getCheckoutFormError">{{getCheckoutFormError}}</p>
        <button class="btn btn-checkout shadow-light" @click="handleShipping()">Continue to payment</button>
        <p class="btn-icon match-height" @click.stop="setCheckoutStep(1)"><i class="fal fa-long-arrow-right"></i>Back to Cart</p>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    const {required, minLength, email, sameAs} = require('vuelidate/lib/validators');
    import {gmapApi} from 'vue2-google-maps'

    export default {
        name: "CheckoutShipping",
        data() {
            return {
                showShippingNotes: false,
                showGiftNotes: false
            };
        },
        computed: {
            ...mapGetters(['getCheckoutStep', 'getItems', 'getShippingCountries', 'getOrder', 'getMember', 'getShippingMethod', 'getGiftNotes', 'getShippingNotes', 'getCheckoutFormError']),
            shippingCountry: {
                get() {
                    let country = this.getMember.DefaultShippingAddress.Country;
                    if (!country) {
                        country = this.getMember.DefaultShippingAddress.DefaultCountry;
                    }
                    return country;
                },
                set(country) {
                    this.getMember.DefaultShippingAddress.Country = country;
                }
            },
            shippingMethod: {
                get() {
                    return this.getShippingMethod;
                },
                set(shippingMethod) {
                    this.setShippingMethod(shippingMethod);
                }
            },
            shippingNotes: {
                get() {
                    return this.getShippingNotes;
                },
                set(shippingNotes) {
                    this.setShippingNotes(shippingNotes);
                }
            },
            giftNotes: {
                get() {
                    return this.getGiftNotes;
                },
                set(giftNotes) {
                    this.setGiftNotes(giftNotes);
                }
            },
            google: gmapApi
        },
        methods: {
            ...mapActions(['setCheckoutStep', 'saveShipping', 'setShippingMethod', 'setShippingNotes','setGiftNotes']),
            handleShipping() {
                let data = new FormData();
                data.append('Member', JSON.stringify(this.getMember));
                data.append('ShippingMethod', this.getShippingMethod);
                data.append('ShippingNotes', this.getShippingNotes);
                data.append('GiftNotes', this.getGiftNotes);

                if (this.$gtm.enabled()) {
                    let itemsList = []

                    this.getItems.forEach((item) => {
                        let product = item.Product;

                        itemsList.push({
                            'item_id': product.ID,
                            'item_name': product.Title,
                            'price': product.LocalisedPrice,
                            'item_category': product.ProductType,
                            'quantity': item.Quantity
                        })
                    })

                    window.dataLayer?.push({ecommerce: null});
                    window.dataLayer?.push({
                        'event': 'add_shipping_info',
                        'ecommerce': {
                            'items': itemsList
                        }
                    });
                }

                this.saveShipping(data);
            },
            autoCompleteAddress(place) {
                if (place) {
                    let addressData = [];
                    for (let i = 0; i < place.address_components.length; i++) {
                        let addressType = place.address_components[i].types[0],
                            value = place.address_components[i]['long_name'];
                        addressData[addressType] = value;
                    }

                    let premise = typeof (addressData['premise']) !== 'undefined' ? addressData['premise'] : '';
                    let street = typeof (addressData['street_number']) !== 'undefined' ? addressData['street_number'] : '';
                    let route = typeof (addressData['route']) !== 'undefined' ? addressData['route'] : '';
                    let suburb = typeof (addressData['sublocality_level_1']) !== 'undefined' ? addressData['sublocality_level_1'] : '';
                    let city = typeof (addressData['locality']) !== 'undefined' ? addressData['locality'] : '';
                    let state = typeof (addressData['administrative_area_level_1']) !== 'undefined' ? addressData['administrative_area_level_1'] : '';
                    let code = typeof (addressData['postal_code']) !== 'undefined' ? addressData['postal_code'] : '';
                    const streetAddress = premise + ' ' + street + ' ' + route;

                    if(!state){
                        state = suburb;
                        suburb = '';
                    }

                    if(!city){
                        city = state;
                    }

                    this.getMember.DefaultShippingAddress.Address = streetAddress.trim();
                    this.getMember.DefaultShippingAddress.Suburb = suburb;
                    this.getMember.DefaultShippingAddress.City = city;
                    this.getMember.DefaultShippingAddress.State = state;
                    this.getMember.DefaultShippingAddress.PostalCode = code;

                    this.getMember.DefaultShippingAddress.FullAddress =
                        this.getMember.DefaultShippingAddress.Address + ' ' +
                        this.getMember.DefaultShippingAddress.Suburb + ' ' +
                        this.getMember.DefaultShippingAddress.City + ' ' +
                        this.getMember.DefaultShippingAddress.State + ' ' +
                        this.getMember.DefaultShippingAddress.PostalCode;
                }
            },
            autocompleteOptions() {
                let country = this.shippingCountry;
                return {componentRestrictions: {country: country}};
            }
        }
    }
</script>

<style scoped>

</style>
